<template>
   <div class="sd_login_page">
      <div class="form_box">
         <div class="title">
            <h5>忘记密码</h5>
         </div>
         <div class="input_box">
            <h5>找回密码</h5>
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm"   class="demo-ruleForm">
               <el-form-item prop="phone">
                  <el-input type="text" v-model="ruleForm.phone" maxlength="11" placeholder="手机号码"></el-input>
               </el-form-item>
               <el-form-item prop="code">
                  <el-row>
                     <el-col :span="15">
                        <el-input v-model="ruleForm.code" placeholder="验证码"></el-input>
                     </el-col>
                     <el-col :span="1">

                     </el-col>
                     <el-col :span="8">
                        <el-button type="primary" class="post_btn" v-if="show" @click="codePost">发送验证码</el-button>
                        <el-button class="post_btn" v-else>{{count}} s</el-button>
                     </el-col>
                  </el-row>
               </el-form-item>
               <el-form-item prop="password">
                  <el-input type="password" v-model="ruleForm.password" placeholder="新密码"></el-input>
               </el-form-item>
               <el-form-item prop="password2">
                  <el-input type="password" v-model="ruleForm.password2" placeholder="重新输入密码"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" class="login_btn" @click="submitForm('ruleForm')">确认</el-button>
               </el-form-item>
               <el-form-item>
                  <div class="links">
                     <router-link to="/login">我有账号去登录</router-link>
                     <router-link to="/register">注册新账号</router-link>
                  </div>
               </el-form-item>
            </el-form>
         </div>
      </div>
   </div>
</template>


<script>
   export default {
      name: 'sd_password_page',
      data() {
         var validatorPhone = function (rule, value, callback) {
            if (value === '') {
               callback(new Error('手机号不能为空'))
            } else if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式错误'))
            } else {
               callback();
            }
         };
         var validatePass = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请输入密码'));
            } else {
               if (this.ruleForm.password2 !== '') {
                  this.$refs.ruleForm.validateField('password2');
               }
               callback();
            }
         };
         var validatePass2 = (rule, value, callback) => {
            if (value === '') {
               callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
               callback(new Error('两次输入密码不一致!'));
            } else {
               callback();
            }
         };
         return {
            ruleForm: {
               phone: '', //手机号
               code: '', //验证码
               password: '',
               password2: '',
            },
            count: 60,
            timer: null,
            show: true,
            rules: {
               phone: [
                  { validator: validatorPhone, trigger: 'blur' }
               ],
               code: [{
                  required: true,
                  message: '请输入验证码',
                  trigger: 'blur'
               }, ],
               password: [{
                  validator: validatePass,
                  trigger: 'blur'
               }],
               password2: [{
                  validator: validatePass2,
                  trigger: 'blur'
               }],
            }
         }
      },
      mounted() {

      },
      methods: {
         submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  _this.$api.updatePassword({
                     ..._this.ruleForm
                  }).then(res => {
                     if (res.code == 200) {
                        _this.$message({
                           message: '修改成功！',
                           type: 'success'
                        });
                        _this.$delCookie('sd_token');
                        setTimeout(function(){
                           _this.$router.replace('/login');
                        },1000)
                     } else {
                        _this.$message.error(res.msg);
                     }
                  }).catch(function(error) {
                     _this.$message.error(error.msg);
                  });
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
         //发送验证码
         codePost() {
            var _this = this;
            var reg_phone = /^1\d{10}$/;
            if(!reg_phone.test(this.ruleForm.phone)){
               _this.$message.error('请填写正确的手机号码！');
               return false;
            }
            _this.$api.sendCode({
               phone: this.ruleForm.phone
            }).then(res => {
               if (res.code == 200) {
                  this.$message({
                     message: '发送成功！',
                     type: 'success'
                  });
                  this.setTime();
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         setTime(){
            const TIME_COUNT = 60;
            if (!this.timer) {
               this.count = TIME_COUNT;
               this.show = false;
               this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                     this.count--;
                  } else {
                     this.show = true;
                     clearInterval(this.timer);
                     this.timer = null;
                  }
               }, 1000)
            }
         },
      }
   }
</script>
<style lang="less">

</style>
